// car image
import loard from "../images/loardCar.webp";
import budi from "../images/budiCar.webp";
import Resela from "../images/raselaCar.webp";
import Xorsche from "../images/XorscheCar.webp";
import loard2018 from "../images/loardCar2018.webp";
import loard2020 from "../images/loardCar2020.webp";
// car image

// carBtn image
import ferrari from "../images/ferrari.webp";
import tesla from "../images/tesla.webp";
import bmw from "../images/bmw.webp";
import toyota from "../images/toyota.webp";
import mini from "../images/mini.webp";
import ford from "../images/ford.webp";
// carBtnTxtImg image

export const Car = [
  {
    id:5,
    cardImg: loard,
    title: "lord 2019",
    prizeCurrent: "154.56",
    prizeClose: "$168.00",
    off: "8%",
    like: false,
  },
  {
    id:6,
    cardImg: budi,
    title: "budi 2017",
    prizeCurrent: "212.44",
    prizeClose: "$212.44",
    off: "6%",
    like: false,
  },
  {
    id:7,
    cardImg: Resela,
    title: "resla 2015",
    prizeCurrent: "90.90",
    prizeClose: "$101.00",
    off: "10%",
    like: false,
  },
  {
    id:8,
    cardImg: Xorsche,
    title: "Xorsche 2018",
    prizeCurrent: "224.13",
    prizeClose: "$241.00",
    off: "7%",
    like: false,
  },
  {
    id:9,
    cardImg: loard2018,
    title: "loard 2018",
    prizeCurrent: "219.48",
    prizeClose: "$236.00",
    off: "7%",
    like: false,
  },
  {
    id:10,
    cardImg: loard2020,
    title: "loard 2020",
    prizeCurrent: "109.98",
    prizeClose: "$117.00",
    off: "6%",
    like: false,
  },
];

export const carBtnTxtImg = [
  {
    img: ferrari,
    text: "Ferrari",
  },
  {
    img: tesla,
    text: "Tesla",
  },
  {
    img: bmw,
    text: "BMW",
  },
  {
    img: toyota,
    text: "Toyota",
  },
  {
    img: mini,
    text: "Mini",
  },
  {
    img: ford,
    text: "Ford",
  },
];
